<template>
  <div v-show="OldLogin" class="FleetWebbg">
    <div style="height:100vh">
      <Setting v-if="$Global.SettingShow" class="Setting-alert"></Setting>
      <div v-if="!this.haveToken" class="Logo">
        <img class="login_img_banner" src="@/assets/svg/login_img_banner.svg">
        <img class="login_logo" src="@/assets/svg/logo.svg">
        <img @click="Setting()" class="setting">
        <div class="AccPW">
          <div class="mt-4">
            <div class="row p-0 m-0" :class="InputAccgp" style="margin: 0 auto !important">
              <div class="col-2 p-0 m-0 d-flex align-items-center justify-content-center">
                <img class="iconskin" :src="AccInputSrc">
              </div>
              <div class="col-10 p-0 m-0">
                <input ref="account" class="inputbg" @focus="AccInputFocus('focus')"  @blur="AccInputFocus('blur')" v-model="account" :placeholder="$Global.langObj[$Global.lang].account" @keyup.enter="Login()">
              </div>
            </div>
            <div class="row p-0" :class="InputPWgp" style="margin: 20px auto 0px auto !important;position:relative">
              <div class="col-2 p-0 m-0 d-flex align-items-center justify-content-center">
                <img class="iconskin" :src="PWInputSrc">
              </div>
              <div class="col-10 p-0 m-0">
                <input :type="passwordtype" ref="password" class="inputbg" @focus="PWInputFocus('focus')"  @blur="PWInputFocus('blur')" v-model="password" :placeholder="$Global.langObj[$Global.lang].password" @keyup.enter="Login()">
              </div>
              <div class="font h-100 d-flex align-items-center px-2" style="position:absolute;right:0px;width: auto;font-size:16px;">
                <i @click="changePasswordType('close')" v-show="passwordtype != 'password'" class="fa fa-eye" style="cursor:pointer;" aria-hidden="true"></i>
                <i @click="changePasswordType('open')" v-show="passwordtype == 'password'" class="fa fa-eye-slash" style="cursor:pointer;" aria-hidden="true"></i>
              </div>
            </div>
            <div class="errorfontcolor pt-1">   
              <span v-if="passworderror || accounterror">{{$Global.langObj[$Global.lang].incorrect_account_or_password}}</span>
            </div>
          </div>
          <div class="mt-2">
            <div class="row m-0 p-0">
              <div class="col-12 col-md-6 m-0 p-0 d-flex justify-content-center align-items-center" >
                <div style="position:relative;width:20px;height:20px;">
                  <div :class="Iconcheckbox"></div>
                  <input class="Origincheckbox" style="cursor:pointer" type="checkbox" v-on:change="SaveAccountChange()" v-model="SaveAccount">
                </div>&ensp;<label class="font">{{$Global.langObj[$Global.lang].save_Account}}</label>
              </div>
              <div class="col-12 col-md-6 m-0 p-0 ">
                <div class="d-flex justify-content-center align-items-center">
                  <button @click="Login()" class="global-btn mt-2 mt-md-0">
                    {{$Global.langObj[$Global.lang].login}}
                  </button>
                </div>
              </div>
            </div>
            <div class="w-100" style="position:relative;bottom:-30px">
              <a style="position:absolute;left:5px" href="./static/FM-G008 Software operation manual_FleetWebV4.pdf" download="FleetWebV4 operation manual">{{$Global.langObj[$Global.lang].Download_the_operation_manual}}</a>
              <font style="position:absolute;right:5px"  class="font">{{$Global.version}}</font>
            </div>
          </div> 
        </div>
      </div>
      <div class="d-flex justify-content-center w-100">
        <font class="font" style="position:absolute;bottom:10px;">
          {{$Global.langObj[$Global.lang].brower_Google_Chrome_Safari_above}} 
          <!-- &emsp;&emsp; -->
          <!-- {{$Global.langObj[$Global.lang].screen_pixel_above}} -->
        </font>
      </div>
    </div>
  </div>
</template>

<script>
import Setting from '../components/Setting.vue'
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      AccInputSrc:require('@/assets/svg/account.svg'),
      PWInputSrc:require('@/assets/svg/password.svg'),
      InputAccgp:'input-gp',
      InputPWgp:'input-gp',
      account:'',
      password:'',
      SaveAccount:false,
      Iconcheckbox:'Iconcheckbox',
      accounterror:false,
      passworderror:false,
      passwordtype:'password',
      haveToken:false,
      allParams:'',
      OldLogin:false
    }
  },
  components:{
    Setting:Setting
  },
  watch:{
  },
  created(){
    //使用Token進入
    if(this.$route.query.token!==undefined){
      localStorage.setItem('Lang','zh-tw')
      this.$Global.lang = 'zh-tw'
      this.haveToken = true
      this.Login();
    }
    // 取得目前網址
    const urlParams_ = new URLSearchParams(window.location.search);
    const allParams = Object.fromEntries(urlParams_.entries());
    this.allParams = allParams;
    let this_ = this
    // 取得特定參數 代理Token機制
    if(allParams.Data != undefined){
      // console.log(allParams.Data)
      let Data = atob(allParams.Data)
      // console.log(Data)
      const params = new URLSearchParams(Data);
      this.setLocalStorage(params)
      this.$APIjs.ProxyTokenGetToken(params.get("ProxyToken")).then(result=>{
        if(result == 'error'){
          return
        }
        // console.log(result)
        this_.$APIjs.GetReportURL(localStorage.getItem('token'),localStorage.getItem('Lang'),localStorage.getItem('theme')).then(result=>{
          this_.$APIjs.GetUserLatLng(localStorage.getItem('token'),1).then(result=>{
              if(result.Status == 'success'){
                if(result.obj){
                  localStorage.setItem('VehicleLatLngZ',JSON.stringify({"lat":result.obj.cy,"lng":result.obj.cx,"zoom":result.obj.cz}))
                  localStorage.setItem('HistoryLatLngZ',JSON.stringify({"lat":result.obj.cy,"lng":result.obj.cx,"zoom":result.obj.cz}))
                }
              }
            })
            // this.Goto('Dashboard')
            if(allParams.Customer != undefined){
              localStorage.setItem('Customer',allParams.Customer)
            }
            if(allParams.Page !=undefined){
              this.Goto(allParams.Page)  
            }else{
              this.Goto('Vehicle')  
            }
        })
      })
    }else{
      //Login Center開關
      //一般模式 不使用Login Center登入
      this.$Global.SetlocalStorage()
      this.OldLogin = true
      //一般模式 直接進入
      //檢查token有沒有過期 過期跳回Login
      // if(localStorage.getItem('token')){
      //   this.setLocalStorageNormal()
      //   this.$APIjs.TokenLogin(localStorage.getItem('token'),'false').then(result=>{
      //     if(result == 'error'){
      //       return
      //     }
      //     this_.$APIjs.GetReportURL(localStorage.getItem('token'),localStorage.getItem('Lang'),localStorage.getItem('theme')).then(result=>{
      //       this_.$APIjs.GetUserLatLng(localStorage.getItem('token'),1).then(result=>{
      //           if(result.Status == 'success'){
      //             if(result.obj){
      //               localStorage.setItem('VehicleLatLngZ',JSON.stringify({"lat":result.obj.cy,"lng":result.obj.cx,"zoom":result.obj.cz}))
      //               localStorage.setItem('HistoryLatLngZ',JSON.stringify({"lat":result.obj.cy,"lng":result.obj.cx,"zoom":result.obj.cz}))
      //             }
      //           }
      //         })
      //         // this.Goto('Dashboard')
      //         if(allParams.Page !=undefined){
      //           this.Goto(allParams.Page)  
      //         }else{
      //           this.Goto('Vehicle')  
      //         }
      //     })
      //   })
      // }else{
      //   this.$Global.SetlocalStorage()
        // window.location.href = jsonObject['LoginCenter']+jsonObject['SolutionName']+'&Type=Login'
        // Vue.prototype.$Global.Logout('Login')
      // }
    }
  },
  mounted(){
    if(this.$route.query.token===undefined){
      //偵測上一次有沒有記住帳號
      if(localStorage.getItem('Logaccount') != undefined && localStorage.getItem('Logaccount') != ''){
        this.$set(this,"SaveAccount", true)
        this.$set(this,"Iconcheckbox", 'Iconcheckbox-active')
      }else{
        this.$set(this,"SaveAccount", false)
        this.$set(this,"Iconcheckbox", 'Iconcheckbox')
      }
      //進入畫面focus帳號框
      this.$refs.account.focus();
      var this_ = this

      window.addEventListener("storage", (e) => {
        if(e.storageArea.username == undefined || e.storageArea.username == ''){
          setTimeout(() => {
            this_.$APIjs.username = ''
            // this_.$router.push({ name: 'Login' }).catch(()=>{})
            if(this.$route.query.Type != 'Logout' && this.$route.query.Type != undefined){
              // window.location.href = jsonObject['LoginCenter']+jsonObject['SolutionName']+'&Type=Logout'
              this.$Global.Logout('Logout')
            }
          }, 100);
        }else{
          var checkarray = ['username','theme','Lang','Unit','timeformat']
          setTimeout(() => {
            this_.SetEnvironment(e,checkarray)
          }, 100);
        }
      });
      if(localStorage.getItem('Logaccount')==null || localStorage.getItem('Logaccount')==''){

      }else{
        if(localStorage.getItem('Logaccount') == 'null'){
          this.account = ''
        }else{
          this.account = localStorage.getItem('Logaccount')
        }
      }
      this.$Global.CurrentPage = 'Login'
    }

    // if(this.$route.query.token!==undefined){
    //   this.Login();
    // }
  },
  beforeDestroy() {
  },
  methods:{
    setLocalStorageNormal(){
      this.$Global.lang = localStorage.getItem('Lang')
      this.$Global.Unit = localStorage.getItem('Unit')
      this.$Global.Unit_local = localStorage.getItem('Unit')
      this.$Global.theme = localStorage.getItem('theme')
      this.$Global.SetTheme(this.$Global.theme)
      this.$Global.SetThemeNum++;
      this.$Global.timeformat = localStorage.getItem('timeformat')
    },
    setLocalStorage(params){
      // console.log(params)
      localStorage.setItem('Lang',params.get("Lang"))
      this.$Global.lang = params.get("Lang")
      localStorage.setItem('Unit',params.get("Unit"))
      this.$Global.Unit = params.get("Unit")
      this.$Global.Unit_local = params.get("Unit")
      localStorage.setItem('theme',params.get("Theme"))
      this.$Global.theme = params.get("Theme")
      this.$Global.SetTheme(this.$Global.theme)
      this.$Global.SetThemeNum++;
      localStorage.setItem('timeformat',params.get("Timeformat"))
      this.$Global.timeformat = params.get("Timeformat")
      this.$Global.ChangeManageMenuLang()
    },
    changePasswordType(Type){
      switch (Type) {
        case 'close':
          this.passwordtype = 'password'
          break;
        case 'open':
          this.passwordtype = 'text'
          break;      
        default:
          break;
      }
    },
    SetEnvironment(e,checkarray){
      for(var i = 0 ; i< checkarray.length;i++){
        switch (checkarray[i]) {
          case 'username':
            if(e.storageArea[checkarray[i]] != this.$APIjs[checkarray[i]]){
              this.$APIjs.username = e.storageArea[checkarray[i]]
            }
            break; 
          case 'theme':
            if(e.storageArea[checkarray[i]] != this.$Global[checkarray[i]]){
              this.$Global[checkarray[i]] = e.storageArea[checkarray[i]]
              this.$Global.SetTheme(this.$Global.theme)
            }
            break;
          case 'Lang':
            if(e.storageArea[checkarray[i]] != this.$Global[checkarray[i]]){
              this.$Global[checkarray[i]] = e.storageArea[checkarray[i]]
              // location.reload()
              // this.$APIjs.GetLang(this.$Global.lang)
              // this.$APIjs.GetManageLang(e.storageArea.lang)
            }
            break;
          case 'Unit':
            if(e.storageArea[checkarray[i]] != this.$Global[checkarray[i]]){
              this.$Global.Unit_local = e.storageArea.Unit
              switch (this.$Global.Unit_local) {
                case 'km':
                  this.$Global.Unit = this.$Global.langObj[this.$Global.lang].kM
                  break;
                case 'mi':
                  this.$Global.Unit = this.$Global.langObj[this.$Global.lang].mile
                  break;        
                default:
                  break;
              }
            }
            break; 
          case 'timeformat':
            if(e.storageArea[checkarray[i]] != this.$Global[checkarray[i]]){
              this.$Global.timeformat = e.storageArea.timeformat
            }
            break;       
          default:

            break;
        }
      }
    },
    LoginError(){
      this.passworderror = true
      if(this.$route.query.token!==undefined){
        alert(this.$Global.langObj[this.$Global.lang].incorrect_account_or_password)
      }
    },
    Login(){
      if(this.account == '' && this.$route.query.token === undefined){
        this.accounterror = true
        this.passworderror = false
      }else{
        if(this.SaveAccount){
          localStorage.setItem('Logaccount',this.account)
        }else{
          localStorage.setItem('Logaccount','')
        }
        this.accounterror = false
        this.$Global.load = true
        setTimeout(() => {//等loading出現
          localStorage.setItem('Customer','null')
          this.$APIjs.Login(this.account,this.password,this.LoginError,this.$route.query.token).then(result=>{
            if(result == 'error'){
              this.$Global.load = false
              return
            }
            this.$APIjs.GetReportURL(localStorage.getItem('token'),localStorage.getItem('Lang'),localStorage.getItem('theme'))
                this.$Global.load = false
                this.accounterror = false
                this.passworderror = false
                this.$APIjs.GetUserLatLng(localStorage.getItem('token'),1).then(result=>{
                  if(result.Status == 'success'){
                    if(result.obj){
                      localStorage.setItem('VehicleLatLngZ',JSON.stringify({"lat":result.obj.cy,"lng":result.obj.cx,"zoom":result.obj.cz}))
                      localStorage.setItem('HistoryLatLngZ',JSON.stringify({"lat":result.obj.cy,"lng":result.obj.cx,"zoom":result.obj.cz}))
                    }
                  }
                })
                // this.Goto('Dashboard')
                if(this.allParams.Page !=undefined){
                  this.Goto(this.allParams.Page)  
                }else{
                  this.Goto('Vehicle')  
                }    
            })  
          }, 1);
      }
    },
    Setting(){
      this.$Global.SettingShow =true
      this.$Global.ChangeLangNum = 0
    },
    Goto(page){
      this.$router.push({ name: page }).catch(()=>{})
    },
    SaveAccountChange(){
      if(this.SaveAccount){
        this.Iconcheckbox = 'Iconcheckbox-active'
      }else{
        this.Iconcheckbox = 'Iconcheckbox'
      }
    },
    AccInputFocus(status){
      switch (status) {
        case 'focus':
          this.AccInputSrc = require('@/assets/svg/account_active.svg')
          this.InputAccgp = 'input-gp-focus'
          break;
        case 'blur':
          this.AccInputSrc = require('@/assets/svg/account.svg')
          this.InputAccgp = 'input-gp'
          break;
        default:
          break;
      }
    },
    PWInputFocus(status){
      switch (status) {
        case 'focus':
          this.PWInputSrc = require('@/assets/svg/password_active.svg')
          this.InputPWgp = 'input-gp-focus'
          break;
        case 'blur':
          this.PWInputSrc = require('@/assets/svg/password.svg')
          this.InputPWgp = 'input-gp'
          break;
        default:
          break;
      }
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.errorfontcolor{
  color: red;
  height: 25px;
}
.inputbg{
  width: 100%;
  height: 100%;
  border-radius: 0 10px 10px 0;
}
.btn{
  border-radius: 10px;
  border: 1.5px solid #c2c2c2;
  background-color: #2c94d1;
  min-width: 30px;
  min-height: 30px;
}
.Logo{
  position: relative;
  top: calc(50vh + -290px);
}
.login_img_banner{
  box-shadow: 0px -5px 10px 3px rgba(0, 0, 0, 0.2);
  position: absolute;
  top:0;
  z-index: 1;
  border-radius:20px 20px 0 0;
}
.login_logo{
  position: absolute;
  z-index: 1;
}
.AccPW{
  box-shadow: 0px 5px 10px 3px rgba(0, 0, 0, 0.2);
  border-radius:0 0 20px 20px;
  position: absolute;
  height: 280px;
  width: 100%;
}
@media (max-height: 719px) and (min-width: 1024px)  {
  .Logo{
    position: relative;
    top: calc(50vh + -290px);
  }
}
@media (min-width: 320px) and (max-width: 374px) {
  .Logo{
    position: relative;
    top: calc(50vh + -290px);
  }
  .input-gp{
    width: 250px;
    height: 45px;
  }
  .input-gp-focus{
    width: 250px;
    height: 45px;
  }
  .login_img_banner{
    max-width: 300px;
    left: calc(50% + -150px);
  }
  .login_logo{
    max-width: 250px;
    top:60px;
    left: calc(50% + -125px);
  }
  .AccPW{
    top:181px;
    max-width: 300px;
    left: calc(50% + -150px);
  }
  .setting{
    top: 8px;
    left: calc(50% + 100px);
  }
}
@media (min-width: 375px) and (max-width: 767px) {
  .Logo{
    position: relative;
    top: calc(50vh + -290px);
  }
  .input-gp{
    width: 300px;
    height: 45px;
  }
  .input-gp-focus{
    width: 300px;
    height: 45px;
  }
  .login_img_banner{
    max-width: 350px;
    left: calc(50% + -175px);
  }
  .login_logo{
    max-width: 300px;
    top:60px;
    left: calc(50% + -150px);
  }
  .AccPW{
    top:210px;
    max-width: 350px;
    left: calc(50% + -175px);
  }
  .setting{
    top: 8px;
    left: calc(50% + 125px);
  }
}
@media (min-width: 768px) and (max-width: 1023px) {
  .Logo{
    position: relative;
    top: calc(50vh + -290px);
  }
  .input-gp{
    width: 340px;
    height: 45px;
  }
  .input-gp-focus{
    width: 340px;
    height: 45px;
  }
  .login_img_banner{
    max-width: 748px;
    left: calc(50% + -240px);
  }
  .login_logo{
    max-width: 350px;
    top:90px;
    left: calc(50% + -200px);
  }
  .AccPW{
    top:290px;
    max-width: 480px;
    left: calc(50% + -240px);
  }
  .setting{
    top: 8px;
    left: calc(50% + 190px);
  }
}
@media (min-width: 1024px) {
  .input-gp{
    width: 360px;
    height: 45px;
  }
  .input-gp-focus{
    width: 360px;
    height: 45px;
  }
  .login_img_banner{
    max-width: 1020px;
    left: calc(50% + -240px);
  }
  .login_logo{
    max-width: 350px;
    top:90px;
    left: calc(50% + -200px);
  }
  .AccPW{
    top:290px;
    max-width: 480px;
    left: calc(50% + -240px);
  }
  .setting{
    top: 8px;
    left: calc(50% + +190px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue